export default "__VITE_ASSET__BEYnb8DJ__"